import http from "@/utils/request";

const douYinApi = {
  listTraceLog: (traceId) =>
    http.sendRequest({
      METHOD_NAME: "douYin.listTraceLog",
      SECURITY_TYPE: "UserLogin",
      data: { traceId },
      ERROR_CODE: {},
    }),
  retry: (type, data) =>
    http.sendRequest({
      METHOD_NAME: "douYin.retry",
      SECURITY_TYPE: "UserLogin",
      data: { type, data },
      ERROR_CODE: {},
    }),
};

export default douYinApi;
